// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2exK4","productName":"Table_productName__11TDQ"};